import React, { useState, useEffect } from 'react'; 
import { Link } from 'react-router-dom';
import Header from './Header';  
import GoogleMap from './utils/GoogleMap';
import './scss/pitchList.scss';
import api from './services/apiService';

function PitchList() {
  const [pitches, setPitches] = useState([]);

  useEffect(() => {
    const fetchPitches = async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/fetch_pitches.php`);
        const result = response.data;
        if (result.success) {
          setPitches(result.pitches);
        } else {
          console.error('Failed to fetch pitches');
        }
      } catch (error) {
        console.error('Error fetching pitches:', error);
      }
    };

    fetchPitches();
  }, []);

  const addresses = pitches.map(pitch => `${pitch.address_1}, ${pitch.address_2}, ${pitch.town}, ${pitch.county}, ${pitch.postcode}`);

  return (
    <div className="PitchList container">
      <Header />
      <h1>Locations</h1>
      <GoogleMap addresses={addresses} />
      <ul className="btn-list">
        {pitches.map((pitch) => (
          <li key={pitch.pitch_id} className="btn-list-item">
            <Link to={`/pitch/${pitch.pitch_id}`} className="btn-item"><span>{pitch.name}</span><span className='btn-item-address'>{pitch.address_1}, {pitch.address_2}, {pitch.town}, {pitch.county}, {pitch.postcode}</span></Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default PitchList; 